import { tv, type VariantProps } from "tailwind-variants";

export const heroParallaxVariants = tv({
  slots: {
    base: [
      "relative",
      "w-full h-screen sm:h-auto lg:h-[calc(100dvh+120px)]",
      "overflow-hidden",
      "mb-0 lg:mb-2",
    ],
    gradient: ["gradient-circles"],
    container: ["container-fluid", "h-full"],
    wrapper: ["relative", "flex", "w-full", "h-full"],
    floatingImagesWrapper: ["absolute top-0 left-0 w-full h-full z-9"],
    content: [
      "relative z-10",
      "flex flex-col items-center justify-center gap-6",
      "w-full h-[calc(100dvh-120px)]",
      "p-0 sm:p-8 sm:max-w-xl lg:max-w-3xl mx-auto",
    ],
    title: [
      "text-text-neutral-default",
      "max-w-3xl",
      "text-center",
      "px-8",
      "mx-auto",
    ],
    description: ["text-center text-gray-60"],
    bg: ["absolute z-1 inset-0 bottom-12 blur-[40px]"],
  },
});

export type HeroParallaxVariantProps = VariantProps<
  typeof heroParallaxVariants
>;
export type HeroParallaxReturnVariantProps = ReturnType<
  typeof heroParallaxVariants
>;
